import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { fetchQuestions } from "../../../config/data";
import axios from "axios";
import { config } from "../../../config/const";
import "./Quiz.css"; // Ensure you have a Quiz.css file in the same directory

const Quiz = () => {
  const { id } = useParams();
  const [questions, setQuestions] = useState([]);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [score, setScore] = useState(0);
  const [selectedOption, setSelectedOption] = useState("");
  const [isCorrect, setIsCorrect] = useState(null);
  const [quizCompleted, setQuizCompleted] = useState(false); // Added state to track quiz completion

  useEffect(() => {
    const LoadData = async () => {
      const data = await fetchQuestions({ id });
      setQuestions(data);
    };
    LoadData();
  }, [id]); // Added id as a dependency

  const handleOptionSelect = async (option) => {
    setSelectedOption(option);
    const response = await axios.post(`${config.backend_url}/saveAttemptedQ`, {
      questionId: questions[currentQuestionIndex]._id,
      email: localStorage.getItem("email"),
      answer: option,
    });
    if (response.data.isCorrect) {
      setScore(score + 1);
      setIsCorrect(true);
    } else {
      setIsCorrect(false);
    }

    setTimeout(() => {
      if (currentQuestionIndex < questions.length - 1) {
        setCurrentQuestionIndex(currentQuestionIndex + 1);
        setSelectedOption("");
        setIsCorrect(null);
      } else {
        setQuizCompleted(true); // Set quiz completion state to true
        console.log("Quiz completed");
        console.log("Score", score);
      }
    }, 1000); // Delay before moving to the next question
  };

  return (
    <div className="quiz-container">
      <h2>Quiz</h2>
      {!quizCompleted ? (
        questions.length > 0 && (
          <div className="question-container">
            <p>{questions[currentQuestionIndex].question}</p>
            <div className="options-container">
              {questions[currentQuestionIndex].options.map((option, index) => (
                <button
                  key={index}
                  className={`option-button ${
                    selectedOption === option
                      ? isCorrect
                        ? "correct"
                        : "incorrect"
                      : ""
                  }`}
                  onClick={() => handleOptionSelect(option)}
                  disabled={selectedOption !== ""}
                >
                  {option}
                </button>
              ))}
            </div>
          </div>
        )
      ) : (
        // Display score view when the quiz is completed
        <div className="score-container">
          <h3>
            Your Score: {score}/{questions.length}
          </h3>
        </div>
      )}
    </div>
  );
};

export default Quiz;
